export default {"src":"/_next/static/media/azuro-staked.f711e8a4.svg","height":318,"width":318,"blurWidth":0,"blurHeight":0};